module.exports = __webpack_public_path__ + "front/img/kv04.6623d940.png";